/**
 * External dependencies
 */
import { createStore, compose, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';

/**
 * Internal dependencies
 */
import cookieMiddleware from './middlewares/cookieMiddleware';
import getReducers from '../reducers';

// This enables the chrome devtools for redux only in development.
const composeEnhancers = ( process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ) || compose;

export const initStore = ( initialState = {}, { middleware = [], reducers = {} } = {} ) => {
	return createStore(
		getReducers( reducers ),
		initialState,
		composeEnhancers(
			applyMiddleware( ...middleware, thunkMiddleware, cookieMiddleware )
		)
	);
};



// WEBPACK FOOTER //
// ./src/store/index.js